var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.431,
    height: 33.038,
    viewBox: "0 0 36.431 33.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247",
    transform: "translate(453.51 -125.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4451",
    "data-name": "Path 4451",
    d: "M-435.286,158.351q-7.052,0-14.1,0a4.045,4.045,0,0,1-2.692-.892,3.9,3.9,0,0,1-.881-5.021q2.149-3.8,4.312-7.6,4.948-8.717,9.894-17.434a3.82,3.82,0,0,1,2.8-2.036,3.838,3.838,0,0,1,4.116,2c1.133,1.985,2.256,3.977,3.385,5.965l10.782,18.993a3.922,3.922,0,0,1-1.535,5.594,4.4,4.4,0,0,1-2.057.424Q-428.274,158.35-435.286,158.351Zm-2.247-23.285c.2,3.122.364,6,.579,8.882a14.911,14.911,0,0,0,.425,2.525,1.334,1.334,0,0,0,1.343,1.053,1.385,1.385,0,0,0,1.481-.986,8.536,8.536,0,0,0,.4-1.863c.261-2.75.52-5.5.7-8.257a15.3,15.3,0,0,0-.2-2.917,1.724,1.724,0,0,0-.908-1.34,2.524,2.524,0,0,0-3.573,1.334A7.746,7.746,0,0,0-437.533,135.066Zm2.5,19.331a2.4,2.4,0,0,0,2.472-2.427,2.475,2.475,0,0,0-2.468-2.463,2.417,2.417,0,0,0-2.469,2.434A2.357,2.357,0,0,0-435.029,154.4Z",
    transform: "translate(0 0)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.3b3073b5dfa4471d89c65453bb4bc543.svg";
export { ForwardRef as ReactComponent };